import { render, staticRenderFns } from "./TaskBasicInfo.vue?vue&type=template&id=2c8f74d6"
import script from "./TaskBasicInfo.vue?vue&type=script&lang=js"
export * from "./TaskBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports